import styled from "styled-components";

export const CaptionContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: ${(props) => (props.smallruler ? "center" : "space-evenly")};
  align-items: center;
  font-size: ${(props) => props.fontSize}px;
  color: ${(props) => (props.inblock ? "black" : "white")};
  background-color: ${(props) => (props.inblock ? "white" : "transparent")};
  font-weight: ${(props) => (props.inblock ? "normal" : "bold")};
  padding-top: 20px;
  padding-bottom: 20px;
`;

export const CaptionRuler = styled.div`
  border-bottom: 1px solid lightgrey;
  height: 1px;
  width: ${(props) => (props.smallruler ? 5 : 35)}%;
  margin: ${(props) => (props.smallruler ? 10 : 0)}px;
`;
